import { render, staticRenderFns } from "./gelirKaydiID.vue?vue&type=template&id=22babbd2&scoped=true&"
import script from "./gelirKaydiID.vue?vue&type=script&lang=js&"
export * from "./gelirKaydiID.vue?vue&type=script&lang=js&"
import style0 from "./gelirKaydiID.vue?vue&type=style&index=0&id=22babbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22babbd2",
  null
  
)

export default component.exports